import { ISitecoreFormGenericInput } from '@/interfaces';
import { LinkTypes, Link } from '@/interfaces/forms/information-box.interface';

export function getFormInput(content: ISitecoreFormGenericInput[], formInputId: string): any {
  return content.find((x: any) => x.formInputId?.value === formInputId);
}

export function getFormInputByName(content: ISitecoreFormGenericInput[], name: string): any {
  return content.find((x: any) => x.name === name);
}

export function convertLinksForInformationBoxInterface(links: any[]): Link[] {
  if (!links || links.length == 0) return [];

  const convertedLinks = links.map((link: any) => ({
    title: link.fields?.link?.value?.text,
    url: link.fields?.link?.value?.href,
    type: link.fields?.linkType?.value,
  }));
  return convertedLinks;
}
